module.exports = __webpack_public_path__ + "media/images/main/cover-bbcad1ed7e6722423cd665746d395bfd.jpg";